import SpriteSymbol from "../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "storage",
  "use": "storage-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"storage\"><defs><linearGradient x1=\"50%\" y1=\"100%\" x2=\"50%\" y2=\".72%\" id=\"storage_b\"><stop stop-color=\"#FFF\" offset=\"0%\" /><stop stop-color=\"#FFF\" stop-opacity=\"0\" offset=\"100%\" /></linearGradient><path d=\"M13.5.866l7.392 4.268a3 3 0 011.5 2.598v8.536a3 3 0 01-1.5 2.598L13.5 23.134a3 3 0 01-3 0l-7.392-4.268a3 3 0 01-1.5-2.598V7.732a3 3 0 011.5-2.598L10.5.866a3 3 0 013 0z\" id=\"storage_a\" /></defs><g fill=\"none\" fill-rule=\"evenodd\"><use fill=\"#228AF2\" xlink:href=\"#storage_a\" /><use fill=\"url(#storage_b)\" style=\"mix-blend-mode:soft-light\" xlink:href=\"#storage_a\" /><path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M19.392 10H4.608v6.268L12 20.536l7.392-4.268z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./icons/storage.svg
// module id = 1014
// module chunks = 0